import CohortLookup from '../api/cohortLookup';
import { applicationFetchAll } from './applicationActions';

export const fetchCohortLookups = applicationFetchAll(CohortLookup);
